export const PRODUCT_ID_DATA_BUTTON = '11935473';
export const PRODUCT_ID_MASTER_SN = '999999994';
export const PRODUCT_ID_SHS = 'shs';
export const PRODUCT_ID_SHS_UNPROCESSED_CHANGES = 'unprocessedChanges';
export const PRODUCT_ID_E_SIM = 'esim';
export const PRODUCT_ID_E_SIM_ACCESS_SERVICE = 'accessService';
export const PRODUCT_ID_TOGETHER_FREE_OWNER = 'cugOwner';
export const PRODUCT_ID_TOGETHER_FREE_MEMBER = 'cugMember';
export const PRODUCT_ID_LOVE = 'convergentGroup';
export const PRODUCT_ID_CHAINED_PREPAID_BENEFIT_INITIAL_OFFER = '#100GB_BENP';
export const PRODUCT_ID_CHAINED_PREPAID_BENEFIT_OFFER_DETAILS = '#25GB_BEN_DET_IN';
export const PRODUCT_ID_POSTPAID_CHRISTMAS_OFFER = '#100GB_BEN';
export const PRODUCT_ID_PREPAID_STARTER_PACK_DATA_OFFER = '13294573';
export const PRODUCT_ID_PREPAID_STARTER_PACK_VOICE_OFFER = '13394459';
export const PRODUCT_ID_AUTOMATIC_REFILL = 'prepaidBalanceRecharge';

export const TARIFF_OPTION_ID_E_SIM_NEW = 'esim_new';
export const TARIFF_OPTION_ID_E_SIM_ROLLBACK = 'esim_rollback';
export const TARIFF_OPTION_ID_PREPAID_STARTER_PACK_DETAIL = 'BEN10GB_DET_IN';

export const OFFERING_OPERATION_COMPATIBILITY_WITH = 'compatibilityWith';
export const OFFERING_OPERATION_SHARING_SERVICE_ELIGIBILITY = 'sharingServiceEligibility';
export const OFFERING_OPERATION_CONVERGENT_ELIGIBLE_SUBSCRIPTIONS =
  'convergentEligibileSubscriptions';
export const OFFERING_OPERATIONS = [
  OFFERING_OPERATION_COMPATIBILITY_WITH,
  OFFERING_OPERATION_SHARING_SERVICE_ELIGIBILITY,
  OFFERING_OPERATION_CONVERGENT_ELIGIBLE_SUBSCRIPTIONS,
];

export const INVENTORY_FILTER_INCLUDE_DETAILS = 'includeDetails';

export const ORDER_ACTION_ADD = 'add';
export const ORDER_ACTION_DELETE = 'delete';
export const ORDER_ACTION_MODIFY = 'modify';
export const ORDER_ACTION_ADD_CHARACTERISTIC = 'addCharacteristic';
export const ORDER_ACTION_DELETE_CHARACTERISTIC = 'deleteCharacteristic';

export const ORDER_CATEGORY_E_SIM = 'eSIMOrder';
export const ORDER_CATEGORY_SHARING_SERVICE = 'SharingServiceOrder';
export const ORDER_CATEGORY_AUTOMATIC_REFILL = 'PrepayBalanceRechargeOrder';
export const ORDER_CATEGORIES = [
  ORDER_CATEGORY_E_SIM,
  ORDER_CATEGORY_SHARING_SERVICE,
  ORDER_CATEGORY_AUTOMATIC_REFILL,
];

export const ORDER_CHANNEL_WEB = 'web';
export const ORDER_CHANNELS = [ORDER_CHANNEL_WEB];

export const ORDER_ITEM_RELATIONSHIP_TYPE_IS_PREREQUISITE = 'isPrerequisite';
export const ORDER_ITEM_RELATIONSHIP_TYPE_HAS_PREREQUISITE = 'hasPrerequisite';

export const CHARACTERISTIC_MASTER_SN = 'master_sn';
export const CHARACTERISTIC_TOGETHER_FREE_OWNER = 'cugMaster';
export const CHARACTERISTIC_TOGETHER_FREE_MEMBER = 'cugSlave';
export const CHARACTERISTIC_TOGETHER_FREE_MEMBER_ADDING = 'cugSlaveAdding';
export const CHARACTERISTIC_TOGETHER_FREE_MEMBER_REJECTED = 'cugSlaveRejected';
export const CHARACTERISTIC_TOGETHER_FREE_MEMBER_EXPIRED = 'cugSlaveExpired';

export const FILTER_ONLY_BASIC_PRODUCT = 'onlyBasicProduct';
export const CHARACTERISTIC_BOUND_DATE = 'agreement:boundDate';
export const CHARACTERISTIC_ELIGIBLE_DATE_FOR_CHANGE = 'agreement:eligibleDateForChange';
